import cn from 'bem-cn';

import { AvatarProps } from './Avatar.types';
import './Avatar.scss';

const b = cn('avatar');

export const Avatar = (props: AvatarProps) => {
    const { image, size = 'medium', alt = 'avatar' } = props;

    // Если image - строка, рендерим img тег
    if (typeof image === 'string') {
        return <img src={image} alt={alt} className={b({ size })} />;
    }

    // Иначе рендерим как React элемент (например, Icon компонент)
    return <>{image}</>;
};
